(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-package/assets/redux/account-slice.js') >= 0) return;  svs.modules.push('/modules/game-package/assets/redux/account-slice.js');

'use strict';

const _RTK = RTK,
  createSlice = _RTK.createSlice;
const getInitialBalance = svs.gamePackage.redux.thunks.getInitialBalance;
const accountSlice = createSlice({
  name: 'account',
  initialState() {
    return {
      activeBalance: undefined,
      isSyndicate: false
    };
  },
  reducers: {
    updateBalance: (state, action) => {
      state.activeBalance = action.payload.balance;
    },
    setActiveAccount: (state, _ref) => {
      let payload = _ref.payload;
      state.activeBalance = payload.balance;
      state.isSyndicate = payload.isSyndicate;
    }
  },
  extraReducers: builder => {
    builder.addCase(getInitialBalance.fulfilled, (state, action) => {
      state.activeBalance = state.activeBalance || action.payload.balance;
    });
  }
});
svs.gamePackage.redux.accountSlice = accountSlice;

 })(window);